import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CreateOrderRequest, RenewOrderRequest, UpdateOrderRequest } from "app/models/products.model";
import { environment } from "environments/environment";

@Injectable()
export class OrderService {
  private apiUrl = environment.apiUrl;
    constructor(
        private httpClient: HttpClient,
      ) {}
    
    createOrder(orderRequest: Partial<CreateOrderRequest>): Observable<any> {
      //return this.httpClient.post<any>(`${this.apiUrl}/createOrder`, orderRequest); 
      return this.httpClient.post<any>('ocmapi/createOrder', orderRequest); 
    }

    updateOrder(orderNumber: string, request: UpdateOrderRequest): Observable<any> {
      //return this.httpClient.post<any>(`${this.apiUrl}/updateOrder`+'/'+orderNumber, request); 
      return this.httpClient.post<any>('ocmapi/updateOrder/'+orderNumber, request);
    }

    getOrder(orderNumber: string): Observable<any> {
      //return this.httpClient.get<any>(`${this.apiUrl}/order`+'/'+orderNumber); 
      return this.httpClient.get<any>('ocmapi/order/'+orderNumber);
    }

    getDecryptedOrderNumber(orderNumber: string): Observable<any> {
      //return this.httpClient.get<any>(`${this.apiUrl}/decryptOrder?encryptedOrderNumber=`+orderNumber);
      return this.httpClient.get<any>('ocmapi/decryptOrder?encryptedOrderNumber='+orderNumber);  
    }

    encryptOrderNumber(orderNumber: string): Observable<any> {  
      //return this.httpClient.get<any>(`${this.apiUrl}/encryptOrder/`+orderNumber); 
      return this.httpClient.get<any>('ocmapi/encryptOrder/' + orderNumber);
    }  

    requestOrderConfirmationEmail(orderNumber: string): Observable<any> {
      return this.httpClient.get<any>('ocmapi/send-email/'+orderNumber);  
    }  

    renewOrder(orderRequest: Partial<RenewOrderRequest>): Observable<any> {
      return this.httpClient.post<any>('ocmapi/renew', orderRequest); 
    }
    
}